import { BRAND_LOGO, BRAND_LOGO_LIGHT } from "@/lib/brand";

/** Mode-aware Flow State Method wordmark. Shows the white logo in dark mode and the
 *  dark-text logo in light mode (toggled by CSS via <html data-theme-mode>). */
export function BrandLogo({ className = "", alt = "The Flow State Method" }) {
  return (
    <>
      <img src={BRAND_LOGO} alt={alt} className={`brand-logo-dark ${className}`} draggable={false} />
      <img src={BRAND_LOGO_LIGHT} alt={alt} className={`brand-logo-light ${className}`} draggable={false} />
    </>
  );
}

/** Compact lockup for headers / footers / auth pages. */
export function BrandMark({ size = "md", className = "", showTagline = false }) {
  const heights = { sm: "h-8", md: "h-10", lg: "h-14", xl: "h-24" };
  const h = heights[size] || heights.md;
  return (
    <div className={`flex items-center gap-3 ${className}`} data-testid="brand-mark">
      <BrandLogo className={`${h} w-auto object-contain`} />
      {showTagline && (
        <div className="hidden md:block border-l border-zinc-700 pl-3 text-[10px] uppercase tracking-[0.3em] text-zinc-400 leading-tight">
          Better<br/>Through<br/>Boxing
        </div>
      )}
    </div>
  );
}
